import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  level: 2,
  className: '',
  fontSize: 'text-4xl',
};

const propTypes = {
  level: PropTypes.oneOf([2, 3]),
  className: PropTypes.string,
  fontSize: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default function SecondaryTitle({
  level,
  className,
  fontSize,
  children,
}) {
  const Level = `h${level}`;

  return (
    <Level
      className={clsx(
        fontSize,
        'font-semibold leading-tight tracking-tight',
        className,
      )}
    >
      {children}
    </Level>
  );
};

SecondaryTitle.defaultProps = defaultProps;
SecondaryTitle.propTypes = propTypes;
